import React from 'react';
import { TrendingUp, Coins, Timer, Zap, Wallet, Activity } from 'lucide-react';

const StatCard = ({ icon: Icon, label, value, subValue, highlight, muted }) => (
  <div
    className={`glass-card p-6 transition-all hover:scale-[1.02] ${highlight ? 'border-[#ff3b3b]/30' : ''} ${
      muted ? 'opacity-80' : ''
    }`}
  >
    <div className="flex items-center gap-3 mb-4">
      <div className={`p-2 rounded-lg ${highlight ? 'bg-[#ff3b3b]/20' : 'bg-white/5'}`}>
        <Icon className={`w-5 h-5 ${highlight ? 'text-[#ff3b3b]' : 'text-white/60'}`} />
      </div>
      <span className="text-white/40 text-sm">{label}</span>
    </div>
    <p className="text-3xl font-display font-bold text-white mb-1">{value}</p>
    {subValue ? <p className="text-white/40 text-sm">{subValue}</p> : null}
  </div>
);

const StatsGrid = ({ stats }) => {
  const formatDuration = (seconds) => {
    const s = Math.max(0, Number(seconds || 0));
    const mins = Math.floor(s / 60);
    const secs = s % 60;
    return `${mins}m ${secs}s`;
  };

  const formatEth = (x) => {
    if (x === null || x === undefined) return null;
    const n = Number(x);
    if (!Number.isFinite(n)) return null;
    return `${n.toFixed(4)} ETH`;
  };

  const buybacks24h = formatEth(stats?.buybacks_eth_24h) || '0.0000 ETH';
  const treasuryBal = formatEth(stats?.treasury_eth_balance) || '0.0000 ETH';

  return (
    <section id="stats" className="py-20 px-6 relative z-10">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 rounded-lg bg-[#ff3b3b]/20">
            <Zap className="w-5 h-5 text-[#ff3b3b]" />
          </div>
          <h2 className="text-3xl font-display font-bold text-white">Factory Stats</h2>
        </div>
        <p className="text-white/50 mb-8">Key metrics</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <StatCard
            icon={TrendingUp}
            label="Tokens (24h)"
            value={Number(stats?.tokens_launched_24h || 0)}
            subValue={`${Number(stats?.tokens_launched_7d || 0)} this week`}
            highlight
          />

          <StatCard
            icon={Coins}
            label="Total Launched"
            value={Number(stats?.tokens_launched_all || 0)}
            subValue="All time"
          />

          <StatCard
            icon={Timer}
            label="Last Cycle Time"
            value={formatDuration(stats?.last_cycle_duration_seconds)}
            subValue="Last cycle duration"
            highlight
          />

          <StatCard
            icon={Wallet}
            label="Buybacks (24h)"
            value={buybacks24h}
            subValue={`${Number(stats?.buybacks_eth_7d || 0).toFixed(4)} ETH this week`}
          />

          <StatCard
            icon={Activity}
            label="Treasury Balance"
            value={treasuryBal}
            subValue="ETH + WETH balance"
          />
        </div>
      </div>
    </section>
  );
};

export default StatsGrid;
